<script setup lang="ts">
// Título de seção da sidebar no padrão do Figma: linha — TÍTULO — linha.
defineProps<{
  title: string;
}>();
</script>

<template>
  <div class="flex items-center gap-[8px] h-[18px] w-full pl-[2px]">
    <span class="flex-1 h-px bg-white/10" />
    <span
      class="shrink-0 text-[9px] font-bold leading-normal uppercase tracking-[0.81px] text-[#A9B4CC] whitespace-nowrap"
    >
      {{ title }}
    </span>
    <span class="flex-1 h-px bg-white/10" />
  </div>
</template>
